import { ComplianceStatus } from './ComplianceStatus.model';
import { TprmRequirementType } from './TprmRequirementType';

export enum ExceptionLevel {
    insured = 'INSURED',
    requirementInstance = 'REQUIREMENT_INSTANCE',
    coverageCriterion = 'COVERAGE_CRITERION',
    evaluatedEntity = 'EVALUATED_ENTITY',
}

export enum ExceptionType {
    permanent = 'PERMANENT',
    untilDate = 'UNTIL_DATE',
    untilCoverageChange = 'UNTIL_COVERAGE_CHANGE',
    untilCoverageExpiration = 'UNTIL_COVERAGE_EXPIRATION',
}

export interface ExceptionInput {
    type: ExceptionType;
    level: ExceptionLevel;
    status: ComplianceStatus | null;
    until?: string | null;
    coverageType?: TprmRequirementType;
    criterionId?: string;
    evaluatedEntityId?: string;
    basedOnMigratedCoverage?: boolean;
    instanceId?: string | null;
    note?: string | null;
}

export interface Exception extends ExceptionInput {
    id: string;
}
